<script setup lang="ts">
// PROPS
interface Props {
    name: string;
    colorClass?: string;
    slashOutlineClass?: string;
}

defineProps<Props>();

defineOptions({
    inheritAttrs: false,
});
</script>

<template>
    <span class="relative inline-flex" :class="colorClass">
        <UIcon :name="name" :class="$attrs.class" />
        <span class="pointer-events-none absolute inset-0 flex items-center justify-center">
            <span
                class="block h-0.5 w-[120%] rotate-45 rounded-full bg-current"
                :class="slashOutlineClass ? ['outline-2', slashOutlineClass] : undefined"
            />
        </span>
    </span>
</template>
